import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaRecycle, FaDatabase, FaCogs, FaLink, FaGlobe, FaUndo, FaMobileAlt } from "react-icons/fa";
import "../styles/HeroSection.css";

const HeroSection = () => {
  return (
    <div id="home" className="hero-section text-white d-flex align-items-center justify-content-center">
      {/* Background Image */}
      <div className="hero-bg"></div>

      {/* Hero Content */}
      <Container className="text-center text-light mt-5 pt-5">
        <h1>Management Systems for Telecommunications Equipment</h1>
        <p>Bhanot International LLC Help Our Partners Secure The Right Assets To Keep The World Connected</p>

        {/* Icons Section */}
        <Row className="icon-row">
          <Col xs={6} md={3} lg={1}>
            <div className="icon-box">
              <FaMobileAlt className="hero-icon" />
              <p>ASSET RECOVERY</p>
            </div>
          </Col>
          <Col xs={6} md={3} lg={1}>
            <div className="icon-box">
              <FaUndo className="hero-icon" />
              <p>REVERSE LOGISTICS</p>
            </div>
          </Col>
          <Col xs={6} md={3} lg={1}>
            <div className="icon-box">
              <FaGlobe className="hero-icon" />
              <p>DISTRIBUTION SERVICES</p>
            </div>
          </Col>
          <Col xs={6} md={3} lg={1}>
            <div className="icon-box">
              <FaLink className="hero-icon" />
              <p>SUPPLY CHAIN FULFILLMENT</p>
            </div>
          </Col>
          <Col xs={6} md={3} lg={1}>
            <div className="icon-box">
              <FaRecycle className="hero-icon" />
              <p>RECYCLING SERVICES</p>
            </div>
          </Col>
          <Col xs={6} md={3} lg={1}>
            <div className="icon-box">
              <FaCogs className="hero-icon" />
              <p>PROCESSES SERVICES</p>
            </div>
          </Col>
          <Col xs={6} md={3} lg={1}>
            <div className="icon-box">
              <FaDatabase className="hero-icon" />
              <p>DATA SANITIZATION</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeroSection;
